/* Fix only the family navigation. Its flow placeholder prevents content jumps. */
(() => {
  if (window.drmStickyMenuInstalled) return;
  window.drmStickyMenuInstalled = true;
  const instances = new Set();
  let frame = 0;
  function update() {
    frame = 0;
    for (const entry of instances) {
      const {nav, placeholder, observer} = entry;
      if (!nav.isConnected) { observer.disconnect(); placeholder.remove(); instances.delete(entry); continue; }
      const style = getComputedStyle(nav);
      const toggle = nav.querySelector('.drm-navigation__toggle');
      const isMobile = matchMedia('(max-width:749px)').matches;
      const barHeight = isMobile && toggle
        ? toggle.getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth)
        : nav.getBoundingClientRect().height;
      placeholder.style.height = `${barHeight}px`;
      const rect = placeholder.getBoundingClientRect();
      const top = Math.max(0, rect.top);
      nav.style.setProperty('--drm-nav-top', `${top}px`);
      nav.style.setProperty('--drm-nav-bar-height', `${barHeight}px`);
      nav.style.left = `${rect.left}px`;
      nav.style.width = `${rect.width}px`;
      document.documentElement.style.setProperty('--drm-sticky-nav-height', `${barHeight}px`);
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function mount() {
    document.querySelectorAll('[data-family-sticky-menu]').forEach(nav => {
      if (nav.dataset.drmStickyReady) return;
      nav.dataset.drmStickyReady = 'true';
      const placeholder = document.createElement('div');
      placeholder.className = 'drm-sticky-menu-placeholder';
      placeholder.setAttribute('role', 'presentation');
      placeholder.textContent = '\u200b'; // Vendor CSS hides empty divs; keep the flow box measurable.
      placeholder.style.height = `${nav.getBoundingClientRect().height}px`;
      nav.before(placeholder);
      nav.classList.add('drm-navigation--fixed');
      const observer = new ResizeObserver(schedule);
      observer.observe(nav);
      instances.add({nav, placeholder, observer});
    });
    update();
  }
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', mount);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', mount) : mount();
})();
